import React, { useState, useContext } from 'react';
import ThemeContext from '../context/theme.Context';
import UserDetailsContext from '../context/userDetails.context';
import LocationsContext from '../context/locations.Context';
import NotificationContext from '../context/notification.Context';
import LoadingContext from '../context/loading.context';
import { Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Collapse from 'react-bootstrap/Collapse';
import Badge from 'react-bootstrap/Badge';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import * as Constants from '../modules/constants';

var Device = function (props) {

    const { userId, token, setUserDetails } = useContext(UserDetailsContext);
    const { locations, activeLocationId, activeGroupIds, setDeviceState, setGroupDevices, setDevices } = useContext(LocationsContext);
    const { showLoading, hideLoading } = useContext(LoadingContext);

    const [detailsVisible, setDetailsVisible] = useState(props.detailsVisible);
    const [deviceDescription, setDeviceDescriptionState] = useState(getDeviceDescription(props.device));
    const [redirectLocation, setRedirectLocation] = useState('');

    const apiHostName = Constants.API_URL;

   /* Up and down buttons should only be enabled if:
    * - The device is online
    * - The minimum / maximum value has not been reached (down -> value should be 2 or greater; up -> value should be 4 or less for SF-series, or 3 or less for IH-series)
    * - The device is turned on
    * */
    function isButtonUpEnabled() {
        if ((props.device.deviceType.startsWith('IH-') && props.device.lastLevel >= 4) || props.device.lastLevel >= 5)
            return false;
        if (!props.device.isOnline)
            return false;
        if (props.device.lastState !== 'On' && props.device.lastState !== 'Warming up' && props.device.lastState !== 'Starting')
            return false;
        return true;
    }

    function isButtonDownEnabled() {
        if (props.device.lastLevel === 1)
            return false;
        if (!props.device.isOnline)
            return false;
        if (props.device.lastState !== 'On' && props.device.lastState !== 'Warming up' && props.device.lastState !== 'Starting')
            return false;
        return true;
    }

    function isButtonPowerEnabled() {
        if (!props.device.isOnline)
            return false;
        // If the device is OFF and the ON function is locked, disable the button as well:
        if (props.device.lastState !== 'On' && props.device.lastState !== 'Warming up' && props.device.lastState !== 'Starting')
            if (props.device.onIsLocked)
                return false;
        return true;
    }

    function toggleOnLockUI() {
        const device = { ...props.device };
        device.onIsLocked = !props.device.onIsLocked;
        setDeviceState(props.locationId, device);
        return true;
    }

    function setCurrentState(newState) {
        // Update state property
        const device = { ...props.device };
        device.lastState = newState;
        setDeviceState(props.locationId, device);
    }
    function setCurrentLevel(newLevel) {
        // Update level property
        const device = { ...props.device };
        device.lastLevel = newLevel;
        setDeviceState(props.locationId, device);
    }
    function setDeviceDescription(newDescription) {
        // Update description property
        const device = { ...props.device };
        device.description = newDescription;
        setDeviceState(props.locationId, device);
    }

    function getDeviceTypeDescription(deviceType) {
        if (deviceType.startsWith('SW-'))
            return 'Powerswitch (' + deviceType + ')';
        else if (deviceType.startsWith('SF-'))
            return 'Bio-ethanol burner (' + deviceType + ')';
        else if (deviceType.startsWith('IH-'))
            return 'Infrared heater (' + deviceType + ')';
        else
            return deviceType;
    }

    function checkStatus(response) {
        if (response.status >= 200 && response.status < 300) {
            return response;
        } else {
            var error = new Error(response.statusText);
            error.response = response;
            if (error.response.status === 401) {
                // Not authorized --> empty user details, so we get redirected to login page
                setUserDetails({ userName: '', email: '', userLocation: { name: '', id: 0 }, token: '' });
            }
            throw error;
        }
    }

    function getActiveGroupId() {

        var groupId;

        if (activeGroupIds && activeGroupIds[getActiveLocationId().toString()])
            groupId = activeGroupIds[getActiveLocationId().toString()].groupId;

        return groupId || 'all';
    }
    function getGroupName(groupId) {
        if (locations[getActiveLocationId().toString()] && locations[getActiveLocationId().toString()].groups && locations[getActiveLocationId().toString()].groups[groupId.toString()])
            return locations[getActiveLocationId().toString()].groups[groupId.toString()].name;

        return 'all';
    }
    function getActiveGroupName() {
        return getGroupName(getActiveGroupId());
    }


    function getActiveLocationId() {
        if (activeLocationId)
            return activeLocationId;
        if (locations)
            return Object.values(locations)[0].id.toString();
        return '0';
    }

    function canManageLocation(location) {
        if (location.owner === userId)
            return true;
        if (location.authorization === 'Manage')
            return true;
        return false;
    }


    function toggleAuto(notificationContext) {
        // For switch-type devices, set the relais to Off/Off in case Auto = On, or to On/On in case Auto = Off
        // Device is AutoOn if lastState = Off/Off. If lastState = On/On (permanent on) or On/Off (permanent off), AutoOn = false (Off/On is currently not supported)
        showLoading();
        if (props.device.lastState === 'Off/Off') {
            // Device was auto-on, so switch auto off and turn lights on by default:
            fetch(apiHostName + '/v1/devices/' + props.device.id + '/' + encodeURIComponent('switchRelais:1=on&2=on'), { method: 'PUT', mode: "cors", headers: { "Authorization": "Bearer " + token } })
                .then(checkStatus)
                .then(() => {
                    setCurrentState('On/On');
                    hideLoading();
                })
                .catch(function (error) {
                    // TODO: set visual cue and error text to be displayed on login screen
                    notificationContext.showMessage({ newMessage: 'Network error.' });
                    hideLoading();
                });

        } else {
            // Device was not auto-on, so set to auto-on now:
            fetch(apiHostName + '/v1/devices/' + props.device.id + '/' + encodeURIComponent('switchRelais:1=off&2=off'), { method: 'PUT', mode: "cors", headers: { "Authorization": "Bearer " + token } })
                .then(checkStatus)
                .then(() => {
                    setCurrentState('Off/Off');
                    hideLoading();
                })
                .catch(function (error) {
                    // TODO: set visual cue and error text to be displayed on login screen
                    notificationContext.showMessage({ newMessage: 'Network error.' });
                    hideLoading();
                });
        }
    }

    function clickPowerButton(notificationContext) {

        showLoading();
        // Depending on the device type, different states may be used...
        if (props.device.deviceType.startsWith('SW-')) {
            // Powerswitch
            // Device is AutoOn if lastState = Off/Off. If lastState = On/On (permanent on) or On/Off (permanent off), AutoOn = false (Off/On is currently not supported)
            //
            if (props.device.lastState === 'On/On') {
                // State was permanent on --> switch off
                fetch(apiHostName + '/v1/devices/' + props.device.id + '/' + encodeURIComponent('switchRelais:1=on&2=off'), { method: 'PUT', mode: "cors", headers: { "Authorization": "Bearer " + token } })
                    .then(checkStatus)
                    .then(() => {
                        setCurrentState('On/Off');
                        hideLoading();
                    })
                    .catch(function (error) {
                        // TODO: set visual cue and error text to be displayed on login screen
                        notificationContext.showMessage({ newMessage: 'Network error.' });
                        hideLoading();
                    });
            }
            else if ((props.device.lastState === 'Off/Off') || (props.device.lastState === 'On/Off')) {
                // State was auto or permanent off --> switch on
                fetch(apiHostName + '/v1/devices/' + props.device.id + '/' + encodeURIComponent('switchRelais:1=on&2=on'), { method: 'PUT', mode: "cors", headers: { "Authorization": "Bearer " + token } })
                    .then(checkStatus)
                    .then(() => {
                        setCurrentState('On/On');
                        hideLoading();
                    })
                    .catch(function (error) {
                        // TODO: set visual cue and error text to be displayed on login screen
                        notificationContext.showMessage({ newMessage: 'Network error.' });
                        hideLoading();
                    });
            }
            else
                ; // Cannot switch individual relais yet, so do nothing...
        }
        else if (props.device.deviceType.startsWith('SF-')) {
            // Bio-ethanol burner
            if (props.device.lastState === 'Idle') {
                fetch(apiHostName + '/v1/devices/' + props.device.id + '/on',
                    { method: 'PUT', mode: "cors", headers: { "Authorization": "Bearer " + token } })
                    .then(checkStatus)
                    .then(() => {
                        setCurrentState('Starting');
                        hideLoading();
                    })
                    .catch(function (error) {
                        // TODO: set visual cue and error text to be displayed on login screen
                        notificationContext.showMessage({ newMessage: 'Network error.' });
                        hideLoading();
                    });
            }
            else if (props.device.lastState === 'On' || props.device.lastState === 'Warming up' || props.device.lastState === 'Starting') {
                fetch(apiHostName + '/v1/devices/' + props.device.id + '/off',
                    { method: 'PUT', mode: "cors", headers: { "Authorization": "Bearer " + token } })
                    .then(checkStatus)
                    .then(() => {
                        setCurrentState('Turning off');
                        hideLoading();
                    })
                    .catch(function (error) {
                        // TODO: set visual cue and error text to be displayed on login screen
                        notificationContext.showMessage({ newMessage: 'Network error.' });
                        hideLoading();
                    });
            }
            else
                ; // Invalid state
        }
        else if (props.device.deviceType.startsWith('IH-')) {
            // Infrared heater
            if (props.device.lastState === 'On') {
                fetch(apiHostName + '/v1/devices/' + props.device.id + '/off', { method: 'PUT', mode: "cors", headers: { "Authorization": "Bearer " + token } })
                    .then(checkStatus)
                    .then(() => {
                        setCurrentState('Off');
                        hideLoading();
                    })
                    .catch(function (error) {
                        // TODO: set visual cue and error text to be displayed on login screen
                        notificationContext.showMessage({ newMessage: 'Network error.' });
                        hideLoading();
                    });
            }
            else if (props.device.lastState === 'Off') {
                fetch(apiHostName + '/v1/devices/' + props.device.id + '/on', { method: 'PUT', mode: "cors", headers: { "Authorization": "Bearer " + token } })
                    .then(checkStatus)
                    .then(() => {
                        setCurrentState('On');
                        hideLoading();
                    })
                    .catch(function (error) {
                        // TODO: set visual cue and error text to be displayed on login screen
                        notificationContext.showMessage({ newMessage: 'Network error.' });
                        hideLoading();
                    });
            }
            else
                hideLoading(); // Cannot switch individual relais yet, so do nothing...
        }
        else
            hideLoading();// invalid state, do nothing
    }



    function setLevel(command, level, notificationContext) {

        showLoading();

        if (props.device.deviceType.startsWith('SF-')) {
            // Bio-ethanol burner
            if (props.device.lastState === 'On' || props.device.lastState === 'Warming up' || props.device.lastState === 'Starting') {
                fetch(apiHostName + '/v1/devices/' + props.device.id + '/' + command, { method: 'PUT', mode: "cors", headers: { "Authorization": "Bearer " + token } })
                    .then(checkStatus)
                    .then(() => {
                        setCurrentLevel(level);
                    })
                    .then(() => {
                        hideLoading();
                    })
                    .catch(function (error) {
                        console.log('request failed', error);   // TODO: set visual cue and error text
                        notificationContext.showMessage({ newMessage: 'Network error.' });
                        hideLoading();
                    });
            }
            else {
                console.log('Level cannot be changed in current state'); // TODO: set visual cue and error text
                hideLoading();
            }
        } else if (props.device.deviceType.startsWith('IH-')) {
            // Infrared heater
            if (props.device.lastState === 'On') {
                fetch(apiHostName + '/v1/devices/' + props.device.id + '/' + command, { method: 'PUT', mode: "cors", headers: { "Authorization": "Bearer " + token } })
                    .then(checkStatus)
                    .then(() => {
                        setCurrentLevel(level);
                    })
                    .then(() => {
                        hideLoading();
                    })
                    .catch(function (error) {
                        console.log('request failed', error);   // TODO: set visual cue and error text
                        notificationContext.showMessage({ newMessage: 'Network error.' });
                        hideLoading();
                    });
            }
            else {
                console.log('Level cannot be changed in current state'); // TODO: set visual cue and error text
                hideLoading();
            }
        }
    }

    function clickUp(notificationContext) {
        var noOfLevels;
        if (props.device.deviceType.startsWith('IH-'))
            noOfLevels = 4;
        else
            noOfLevels = 5;

        if (props.device.lastLevel < noOfLevels)
            setLevel('up', props.device.lastLevel + 1, notificationContext);

    }

    function clickDown(notificationContext) {
        if (props.device.lastLevel > 1)
            setLevel('down', props.device.lastLevel - 1, notificationContext);
    }

    function cyclePowerIndicator(notificationContext) {
        // Only do this for infrared devices, since the device state may be out of sync with the app...
        var newState = 'Off';
        if (props.device.deviceType.startsWith('IH-')) {
            showLoading();
            if (props.device.lastState === 'On')
                newState = 'Off';
            else if (props.device.lastState === 'Off')
                newState = 'On';
            else
                // Invalid state, set set the default to Off:
                newState = 'Off';

            // Let the server know we've updated the state in the App to reflect the actual state:
            fetch(apiHostName + '/v1/devices/' + props.device.id + '/setState:' + newState, { method: 'PUT', mode: "cors", headers: { "Authorization": "Bearer " + token } })
                .then(checkStatus)
                .then(() => {
                    setCurrentState(newState); // Update the app UI
                    hideLoading();
                })
                .catch(function (error) {
                    notificationContext.showMessage({ newMessage: 'Network error.' });
                    hideLoading();
                });

        }
    }

    function cycleLevelIndicator(notificationContext) {
        // Only do this for infrared devices, since the device state may be out of sync with the app...
        if (props.device.deviceType.startsWith('IH-')) {
            showLoading();
            const newLevel = props.device.lastLevel % 4 + 1;

            // Let the server know we've updated the state in the App to reflect the actual state:
            fetch(apiHostName + '/v1/devices/' + props.device.id + '/setLevel:' + newLevel, { method: 'PUT', mode: "cors", headers: { "Authorization": "Bearer " + token } })
                .then(checkStatus)
                .then(() => {
                    setCurrentLevel(newLevel); // Update the app UI
                    hideLoading();
                })
                .catch(function (error) {
                    // TODO: set visual cue and error text to be displayed on login screen
                    notificationContext.showMessage({ newMessage: 'Network error.' });
                    hideLoading();
                });
        }
    }

    function getDeviceDescription(device) {
        if (device.description)
            return device.description;
        return device.deviceType + ' (' + device.id + ')';
    }

    function updateDescription(notificationContext) {
        // Update the device description to 'deviceDescription' - call the REST API for this...
        showLoading();
        fetch(apiHostName + '/v1/devices/' + props.device.id + '/description?newDescription=' + encodeURIComponent(deviceDescription),
            {
                method: 'PUT',
                mode: "cors",
                headers: { "Authorization": "Bearer " + token }
            })
            .then(checkStatus)
            .then(() => {
                setDeviceDescription(deviceDescription); // Update the app UI
                hideLoading();
            })
            .catch(function (error) {
                // TODO: set visual cue and error text to be displayed on login screen
                notificationContext.showMessage({ newMessage: 'Update error.' });
                hideLoading();
            });
    }


    function toggleOnLock(notificationContext) {
        // Update the device description to 'deviceDescription' - call the REST API for this...
        showLoading();
        var isLocked = props.device.onIsLocked ? "off" : "on";
        fetch(apiHostName + '/v1/devices/' + props.device.id + '/lock:' + isLocked,
            {
                method: 'PUT',
                mode: "cors",
                headers: { "Authorization": "Bearer " + token }
            })
            .then(checkStatus)
            .then(() => {
                toggleOnLockUI(); // Update the app UI
                hideLoading();
            })
            .catch(function (error) {
                // TODO: set visual cue and error text to be displayed on login screen
                notificationContext.showMessage({ newMessage: 'Update error.' });
                hideLoading();
            });
    }

    function addDeviceToGroup(notificationContext) {
        setRedirectLocation('/assignDeviceToGroup');
    }

    function removeDeviceFromGroup(notificationContext) {
        if (window.confirm("Are you sure you want to remove device\n'" + getDeviceDescription(props.device) + "'\nfrom group '" + getActiveGroupName() + "'?") === false)
            return;

        // Now actually remove the device from the group:
        showLoading();
        fetch(apiHostName + '/v1/devices/' + props.device.id + '/group?groupId=' + getActiveGroupId(),
            {
                method: 'DELETE',
                mode: "cors",
                headers: { "Authorization": "Bearer " + token }
            })
            .then(checkStatus)
            .then(() => {
                // And reflect this in local state in order to update the UI:
                var newDeviceIds = [];
                locations[props.locationId.toString()].groups[getActiveGroupId()].deviceIDs.forEach(devId => { if (devId !== props.device.id) newDeviceIds.push(devId); });
                setGroupDevices(props.locationId, getActiveGroupId(), newDeviceIds);
                hideLoading();
            })
            .catch(function (error) {
                // TODO: set visual cue and error text to be displayed on login screen
                notificationContext.showMessage({ newMessage: 'Remove error.' });
                hideLoading();
            });

    }


    function deleteDevice(notificationContext) {

        if (window.confirm("Are you sure you want to delete device\n'" + getDeviceDescription(props.device) + "'?\n\nNOTE: You will not be able to operate the device any more if you\ndelete it unless you add the device to the app again.") === false)
            return;


        // Now actually remove the device from the user's location:
        showLoading();
        fetch(apiHostName + '/v1/devices/' + props.device.id,
            {
                method: 'DELETE',
                mode: "cors",
                headers: { "Authorization": "Bearer " + token }
            })
            .then(checkStatus)
            .then(() => {
                // And reflect this in local state in order to update the UI:
                // Remove the device from all groups:
                var newDeviceIds;
                Object.values(locations[props.locationId.toString()].groups).forEach(group => {
                    // Get this group's deviceIDs and remove the current device from it:
                    if (group.id) {
                        newDeviceIds = [];
                        group.deviceIDs.forEach(devId => {
                            console.log("Looping device " + devId);
                            if (devId !== props.device.id) newDeviceIds.push(devId);
                        });
                        setGroupDevices(props.locationId, group.id, newDeviceIds);
                    }
                });

                // Remove the device from this location:
                var newDevices = {};
                Object.values(locations[props.locationId.toString()].devices).forEach(device => {
                    // Add all devices except the current one to the list:
                    if (device.id !== props.device.id)
                        newDevices[device.id] = device;
                });
                setDevices(props.locationId, newDevices);

                hideLoading();
            })
            .catch(function (error) {
                // TODO: set visual cue and error text to be displayed on login screen
                notificationContext.showMessage({ newMessage: 'Cannot remove device.' });
                hideLoading();
            });
    }

    return (
        redirectLocation ?
            <Redirect to={{ pathname: redirectLocation, state: { deviceId: props.device.id, description: getDeviceDescription(props.device), locationId: props.locationId } }} />
            :
            <ThemeContext.Consumer>
                {(themeContext) => (
                    <NotificationContext.Consumer>
                        {(notificationContext) => (
                            <React.Fragment>
                                <Card bg={themeContext.theme} text={themeContext.textColor}>
                                    <Card.Body style={{ paddingLeft: '6px', paddingRight: '6px' }}>
                                        <Card.Title>
                                            <Button variant={themeContext.theme} onClick={() => setDetailsVisible(!detailsVisible)}>
                                                {detailsVisible &&
                                                    <FontAwesomeIcon icon="angle-double-up" />
                                                }
                                                {!detailsVisible &&
                                                    <FontAwesomeIcon icon="angle-double-down" />
                                                }
                                            </Button>
                                            <span>{getDeviceDescription(props.device)}</span>

                                            <ButtonGroup className="float-right">
                                                {(props.device.deviceType.startsWith('SF-') || props.device.deviceType.startsWith('IH-')) &&
                                                    <React.Fragment>
                                                        <Button variant={themeContext.theme} onClick={() => { clickUp(notificationContext); }} disabled={!isButtonUpEnabled()}><FontAwesomeIcon icon="angle-up" /></Button>
                                                        <Button variant={themeContext.theme} onClick={() => { clickDown(notificationContext); }} disabled={!isButtonDownEnabled()}><FontAwesomeIcon icon="angle-down" /></Button>
                                                    </React.Fragment>
                                                }
                                                {props.device.deviceType.startsWith('SW-') &&
                                                    <React.Fragment>
                                                        <Button variant={themeContext.theme} onClick={() => {
                                                            toggleAuto(notificationContext);
                                                        }}
                                                    >
                                                            {props.device.lastState === 'Off/Off' &&
                                                                <span><FontAwesomeIcon icon="toggle-on" /> Auto</span>
                                                            }
                                                            {!(props.device.lastState === 'Off/Off') &&
                                                                <span><FontAwesomeIcon icon="toggle-off" /> Auto</span>
                                                            }
                                                        </Button>

                                                    </React.Fragment>
                                                }
                                                <Button variant={themeContext.theme} onClick={() => { clickPowerButton(notificationContext); }} disabled={!isButtonPowerEnabled()}><FontAwesomeIcon icon="power-off" /></Button>
                                            </ButtonGroup>
                                        </Card.Title>
                                        <Card.Subtitle>
                                            <Badge variant={themeContext.theme} onClick={() => { cyclePowerIndicator(notificationContext); }} style={{ marginLeft: "5px" }}>
                                                {props.device.lastState === 'Idle' ? 'Off' :
                                                    props.device.lastState === 'Off/Off' ? 'Auto' :
                                                    props.device.lastState === 'On/On' ? 'On' :
                                                    props.device.lastState === 'On/Off' ? 'Off' :
                                                    props.device.lastState}
                                            </Badge>

                                            {(props.device.deviceType.startsWith('SF-') || props.device.deviceType.startsWith('IH-')) &&
                                                <Badge variant={themeContext.theme} onClick={() => { cycleLevelIndicator(notificationContext); }} style={{ marginLeft: "5px" }}>Level: {props.device.lastLevel}</Badge>
                                            }

                                            {!props.device.isOnline &&
                                                <Badge variant="secondary" style={{ marginLeft: "5px" }}>Offline</Badge>
                                            }
                                        </Card.Subtitle>
                                        <Card.Text as="div">
                                            <Collapse in={detailsVisible}>
                                                <div>
                                                    <Table variant={themeContext.theme}>
                                                        <tbody>
                                                            <tr>
                                                                <td width='110em'>Device type</td>
                                                                <td>{getDeviceTypeDescription(props.device.deviceType)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Description</td>
                                                                <td style={{ display: 'flex' }}>
                                                                    <Form.Control type='text' maxLength={50} value={deviceDescription} disabled={!canManageLocation(locations[props.locationId])} onChange={(e) => setDeviceDescriptionState(e.target.value)} />
                                                                    <Button variant='secondary' title="Update description" disabled={!canManageLocation(locations[props.locationId])} onClick={() => updateDescription(notificationContext)}><FontAwesomeIcon icon="edit" /></Button>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td>Lock ON</td>
                                                                <td>
                                                                    <Button variant={themeContext.theme} onClick={() => {
                                                                        toggleOnLock(notificationContext);
                                                                    }}
                                                                    >
                                                                        {props.device.onIsLocked &&
                                                                            <span><FontAwesomeIcon icon="toggle-on" /> Yes</span>
                                                                        }
                                                                        {!props.device.onIsLocked &&
                                                                            <span><FontAwesomeIcon icon="toggle-off" /> No</span>
                                                                        }
                                                                    </Button>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td>Device state</td>
                                                                <td>
                                                                    {props.device.lastState === 'Idle' ? 'Off' :
                                                                        props.device.lastState === 'Off/Off' ? 'Auto (' + props.device.lastState + ')' :
                                                                            props.device.lastState === 'On/On' ? 'On (' + props.device.lastState + ')' :
                                                                                props.device.lastState === 'On/Off' ? 'Off (' + props.device.lastState + ')' :
                                                                                    props.device.lastState}
                                                                </td>
                                                            </tr>
                                                            {props.device.deviceType.startsWith('NOT-USED-SF-') &&
                                                                <tr>
                                                                    <td>Temperature</td>
                                                                    <td>{props.device.lastTemperature}</td>
                                                                </tr>
                                                            }
                                                            {props.device.deviceType.startsWith('SF-') &&
                                                                <tr>
                                                                    <td>Fuel level</td>
                                                                    <td>
                                                                        {props.device.lastFuelLevel === 'L' && 'Low'}
                                                                        {props.device.lastFuelLevel === 'N' && 'Normal'}
                                                                        {props.device.lastFuelLevel === 'H' && 'High'}
                                                                        {props.device.lastFuelLevel !== 'L' && props.device.lastFuelLevel !== 'N' && props.device.lastFuelLevel !== 'H' && 'Unknown'}
                                                                    </td>
                                                                </tr>
                                                            }
                                                            {props.device.deviceType.startsWith('SF-') && props.device.lastPlacement === 'S' &&
                                                                <tr>
                                                                    <td>WARNING</td>
                                                                    <td>
                                                                        Not placed horizontally!
                                                                        </td>
                                                                </tr>
                                                            }
                                                            {props.device.deviceType.startsWith('SF-') && props.device.lastOverheated === true &&
                                                                <tr>
                                                                    <td>WARNING</td>
                                                                    <td>
                                                                        Burner is overheated!
                                                                    </td>
                                                                </tr>
                                                            }
                                                            <tr>
                                                                <td>IP address</td>
                                                                <td>{props.device.lastKnownIP}</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                    <div>
                                                        <Button variant='secondary' title="Delete device" disabled={!canManageLocation(locations[props.locationId])} onClick={() => deleteDevice(notificationContext)}><FontAwesomeIcon icon="trash-alt" /></Button>{' '}
                                                        <Button variant='secondary' title="Add device to group" disabled={!canManageLocation(locations[props.locationId]) || getActiveGroupId() !== 'all'} onClick={() => addDeviceToGroup(notificationContext)}><FontAwesomeIcon icon="plus-circle" /></Button>{' '}
                                                        <Button variant='secondary' title="Remove device from group" disabled={!canManageLocation(locations[props.locationId]) || getActiveGroupId() === 'all'} onClick={() => removeDeviceFromGroup(notificationContext)}><FontAwesomeIcon icon="minus-circle" /></Button>
                                                    </div>

                                                </div>
                                            </Collapse>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </React.Fragment>
                        )}
                    </NotificationContext.Consumer>
                )}
            </ThemeContext.Consumer>

    );

};

export default Device;


// WEBPACK FOOTER //
// ./src/components/Device.js